export default __webpack_public_path__ + "static/web20240430-64e63544f2c8999b439913a674bf65ec.png";